var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyIncidents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 129,
    viewBox: "0 0 175 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipEmptyIncidents)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.08 83.9445L117.502 110.366C118.744 111.609 120.815 110.514 120.519 108.798L113.774 68.7366L126.052 56.4577L125.904 48.765C131.289 42.4629 135.55 35.2731 138.479 27.5212L139.781 24.089C140.461 22.2842 138.686 20.509 136.881 21.1895L133.449 22.4913C125.668 25.4205 118.478 29.6811 112.205 35.066L104.513 34.9181L92.2339 47.1969L52.1724 40.4805C50.4563 40.1846 49.3912 42.2853 50.6043 43.4984L77.0259 69.9201L69.3332 77.6128L50.4859 74.4469C49.9534 74.3582 49.4208 74.5357 49.0361 74.9203L40.6333 83.3528C39.8048 84.1812 40.0711 85.5718 41.1363 86.0156L57.1135 92.9391L55.2495 97.4364L63.5636 105.75L68.0609 103.886L74.9844 119.864C75.4578 120.929 76.8484 121.195 77.6472 120.367L86.0797 111.934C86.4643 111.55 86.6418 111.017 86.5531 110.484L83.3872 91.6373L91.08 83.9445Z",
    fill: "#DEDBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 77.9445L113.502 104.366C114.744 105.609 116.815 104.514 116.519 102.798L109.774 62.7366L122.052 50.4577L121.904 42.765C127.289 36.4629 131.55 29.2731 134.479 21.5212L135.781 18.089C136.461 16.2842 134.686 14.509 132.881 15.1895L129.449 16.4913C121.668 19.4205 114.478 23.6811 108.205 29.066L100.513 28.9181L88.2339 41.1969L48.1724 34.4805C46.4563 34.1846 45.3912 36.2853 46.6043 37.4984L73.0259 63.9201L65.3332 71.6128L46.4859 68.4469C45.9534 68.3582 45.4208 68.5357 45.0361 68.9203L36.6333 77.3528C35.8048 78.1812 36.0711 79.5718 37.1363 80.0156L53.1135 86.9391L51.2495 91.4364L59.5636 99.7505L64.0609 97.8865L70.9844 113.864C71.4578 114.929 72.8484 115.195 73.6472 114.367L82.0797 105.934C82.4643 105.55 82.6418 105.017 82.5531 104.484L79.3872 85.6373L87.08 77.9445Z",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.744 105.52L105.335 114.929",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.755 92.5607L95.0685 99.2475",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4799 36.2853L36.0711 45.6942",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4688 49.2446L51.7524 55.9314",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.917 47.356C115.521 41.752 118.659 35.8041 116.926 34.071C115.193 32.3378 109.245 35.4757 103.641 41.0796C98.037 46.6835 94.8992 52.6314 96.6323 54.3646C98.3655 56.0978 104.313 52.9599 109.917 47.356Z",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7417 67.2339L78.7363 58.2393",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.707 81.1992L92.7016 72.2046",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.649 102.393C140.634 102.393 146.297 96.7088 146.297 89.6966C146.297 82.6845 140.634 77 133.649 77C126.663 77 121 82.6845 121 89.6966C121 96.7088 126.663 102.393 133.649 102.393Z",
    fill: "#6CD646"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.034 84.9138C140.634 85.4851 140.658 86.4346 140.086 87.0345L133.42 94.0345C133.136 94.3318 132.744 94.5 132.333 94.5C131.923 94.5 131.53 94.3318 131.247 94.0345L127.914 90.5345C127.342 89.9346 127.366 88.9851 127.966 88.4138C128.565 87.8425 129.515 87.8656 130.086 88.4655L132.333 90.825L137.914 84.9655C138.485 84.3656 139.435 84.3425 140.034 84.9138Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8919 60.1517L16.027 69.213C16.027 69.43 16.1892 69.5385 16.4054 69.4842L24.6757 65.6861C24.8378 65.5776 24.8919 65.3606 24.7297 65.252L17.3243 59.9347C17.1622 59.8261 16.946 59.9347 16.8919 60.1517Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.34 48H154.259C154.042 48 153.934 48.217 154.042 48.3798L158.583 56.3016C158.691 56.4644 158.961 56.4644 159.015 56.3016L163.556 48.3798C163.664 48.217 163.556 48 163.34 48Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.757 9.03034C116.697 9.03034 118.27 7.45132 118.27 5.5035C118.27 3.55568 116.697 1.97666 114.757 1.97666C112.816 1.97666 111.243 3.55568 111.243 5.5035C111.243 7.45132 112.816 9.03034 114.757 9.03034Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3784 16.4638C63.8114 16.4638 64.973 15.2978 64.973 13.8594C64.973 12.421 63.8114 11.255 62.3784 11.255C60.9455 11.255 59.7838 12.421 59.7838 13.8594C59.7838 15.2978 60.9455 16.4638 62.3784 16.4638Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.378 127.464C132.811 127.464 133.973 126.298 133.973 124.859C133.973 123.421 132.811 122.255 131.378 122.255C129.945 122.255 128.784 123.421 128.784 124.859C128.784 126.298 129.945 127.464 131.378 127.464Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 24H9.0164C9.2737 20.091 12.5259 17 16.5 17L16.5423 17.0001C18.023 12.3602 22.3691 9 27.5 9C33.6895 9 38.7369 13.8898 38.99 20.0171C39.1586 20.0058 39.3286 20 39.5 20C42.378 20 44.8775 21.6211 46.135 24H66",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118 74H126.016C126.274 70.091 129.526 67 133.5 67L133.542 67.0001C135.023 62.3602 139.369 59 144.5 59C150.689 59 155.737 63.8898 155.99 70.0171C156.159 70.0058 156.329 70 156.5 70C159.378 70 161.877 71.6211 163.135 74H174",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipEmptyIncidents"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 104,
    fill: "white",
    transform: "translate(34 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIncidents);
export default __webpack_public_path__ + "static/media/EmptyIncidents.e559071585c09f1093a2174dd0c92464.svg";
export { ForwardRef as ReactComponent };